import controller from './batch.controller';
import template from './batch.html';
import './batch.scss';

export default {
	controller,
	template,
	bindings: {},
};
